import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface IsicState {
  error: any
  success: any
  isic: any[]
  isicChildren: any[]
}

export const useIsicStore = defineStore('isic', {
  state: (): IsicState => ({
    error: null,
    success: null,
    isic: [],
    isicChildren: [],
  }),

  getters: {
    getIsicAdd: (state) => state.success,
    getIsicAddError: (state) => state.error,
    getIsicFetch: (state) => state.isic,
    getIsicFetchChildren: (state) => state.isicChildren,
  },

  actions: {
    async fetchIsic(data?: any) {
      try {
        const response = await api().get('/reservation/isic', data)
        this.isic = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchLevelOneIsic(data?: any) {
      try {
        const response = await api().get('/reservation/isic/parents', data)
        this.isicChildren = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchIsicLevelChildren(parentId: string | number) {
      try {
        const response = await api().get('/reservation/isic/?prentid=' + parentId)
        this.isicChildren = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async addIsicCategory(data: any) {
      try {
        const response = await api().post('/reservation/isic', data)
        this.success = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },
  },
})
